import { render, staticRenderFns } from "./VerifyAccountFirstStep.vue?vue&type=template&id=28206e87&scoped=true&"
import script from "./VerifyAccountFirstStep.vue?vue&type=script&lang=js&"
export * from "./VerifyAccountFirstStep.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccountFirstStep.vue?vue&type=style&index=0&id=28206e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28206e87",
  null
  
)

export default component.exports